import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Form, Button, Container, Dropdown, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { State } from "../../reducers";
import { CommonUser } from '../../types';
import "./ExerciseSelector.css";
import { Link } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import { hideSideBar, showSideBar } from "../../actions/navBar.actions";
import BrowserAlert from "../../components/BrowserAlert/BrowserAlert";
import * as bluetooth from '../../utils/bluetooth';
import { useResponsive } from "../../utils/useResponsive";

interface RouteProps {
  id: string;
}

interface ExerciseSelectorProps extends RouteComponentProps<RouteProps>, WithTranslation {
  user: CommonUser;
  firstName: string;
  userNotFound: boolean;
  dispatch: Dispatch<any>;
}

const mapStateToProps = (state: State) => ({
  user: state.authentication.user,
  firstName: state.userProfile.firstName,
  userNotFound: state.userProfile.failed
});

const ExerciseSelectorComponent: React.FC<ExerciseSelectorProps> = (props) => {
  const { isMobile, isDesktop } = useResponsive();
  const [state, setState] = React.useState({
    strength: "Click to start",
    selectedWorkout: 'raw',
    selectedSetup: 'hangboard',
    title: 'hangboard',
    showResults: false,
    notes: "",
    graphDisplay: true,
  });

  const setupOptions = [
    {
      key: "hangboard",
      text: "hangboard",
      value: "hangboard"
    },
    {
      key: "lift",
      text: "lift",
      value: "lift"
    },
    {
      key: "portable",
      text: "portable",
      value: "portable"
    }
  ];

  const handleSetupChange = (e: any, data: any) => {
    setState(prev => ({ ...prev, selectedSetup: data.value }));
  };

  React.useEffect(() => {
    props.dispatch(hideSideBar());
  }, [props.dispatch]);

  const onChange = () => {
    if (state.graphDisplay) {
      onUnChecked();
    } else {
      onChecked();
    }
  };

  const onChecked = () => {
    setState(prev => ({ ...prev, graphDisplay: true }));
  };

  const onUnChecked = () => {
    setState(prev => ({ ...prev, graphDisplay: false }));
  };

  const textChanged = (e: any) => {
    setState(prev => ({ ...prev, notes: e.target.value }));
  };

  const navigate = () => {
    props.dispatch(showSideBar());
    props.history.push('/exercise-launcher');
  };

  return (
    <React.Fragment>
      <div className="center">
        <span className="centerSpan">
          <Icon
            className="clickable exerciseIcon"
            name="arrow left"
            onClick={navigate}
          />
        </span>
        <Container className="exercise-selector-center">
          <Form style={{ width: "100%" }}>
            <Form.Group widths="equal">
              <Form.Field>
                <label>{props.t('0.setup')}</label>
                <Dropdown
                  fluid
                  selection
                  options={setupOptions}
                  defaultValue={setupOptions[0].value}
                  onChange={handleSetupChange}
                />
              </Form.Field>
            </Form.Group>
            <Form.TextArea
              label={props.t('0.notes')}
              onChange={textChanged}
              style={{ flex: 0.8, borderWidth: 1, minHeight: 40 }}
            />
          </Form>
        </Container>
        <div className="bottom-absolute-flex-column">
          {!bluetooth._supported && <BrowserAlert />}
          {isDesktop && (
            <Button
              className="ui button"
              primary={true}
              disabled={!bluetooth._supported}
              style={{ width: 150, height: 40 }}
              as={Link}
              to={{ pathname: "/exercise", state: state }}
            >
              {props.t('common:btn.start')}
            </Button>
          )}
          {isMobile && (
            <Button
              className="ui button"
              primary={true}
              disabled={!bluetooth._supported}
              style={{ width: "65vw", height: 40 }}
              as={Link}
              to={{ pathname: "/exercise", state: state }}
            >
              {props.t('common:btn.start')}
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation('workout')(connect(mapStateToProps)(ExerciseSelectorComponent));
